/* global __CLIENT__*/
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import { change } from 'redux-form';
import FieldError from '../form/FieldError';

if (__CLIENT__) {
  require('react-select/dist/react-select.css');
}

@connect()
export default class SingleSelectBox extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    options: PropTypes.instanceOf(Array),
    value: PropTypes.any,
    field: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    formName: PropTypes.string,
    small: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object
  };

  onChange = (obj) => {
    const { dispatch, formName, field } = this.props;
    dispatch(change(formName, field, obj));
  }

  render() {
    const { input, label, small, meta, ...custom } = this.props;
    const smallText = small ? <small className="text-muted">{small}</small> : null;
    const displayLabel = label ? <label>{label}</label> : null;

    return (<fieldset className="form-group">
      {displayLabel}
      <Select
        autoBlur
        onBlurResetsInput={false}
        options={custom.options}
        onChange={this.onChange}
        placeholder={custom.placeholder}
        {...input}
      />
      {smallText}
      <FieldError meta={meta} />
    </fieldset>);
  }
}



// WEBPACK FOOTER //
// ./src/components/inputs/SingleSelectBox.js